import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { VouchersService } from '../services/vouchers.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Plan } from '../models/payment';
import { interval, of, throwError } from 'rxjs';
import { switchMap, take, catchError, finalize, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionService } from '../services/subscription.service';
interface Package {
  id: number;
  name: string;
  description: string;
  price: number;
  duration: string;
  data?: string;
  devices?: number;
  icon: string;
  iconClass: string;
  popular?: boolean;
  expiration_type?:string;
}
interface PaymentForm{
  phone:string;
  plan_id:string;
  amount:string;
  station:string;
  invoice_id:string;
}

@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.scss'],
})
export class PaymentDetailsComponent implements OnInit {
  payment_method: string = 'wallet';
  is_fixed: boolean = false;
  showPackages: boolean = false;
  showPurchaseModal: boolean = false;
  selectedService: string = '';
  selectedPackage: Plan | null = null;
  phoneNumber: string = '';
  invoice_id:string = '';
  isLoading: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';
  detailForm:FormGroup;
  stationid:string='';
  user_type:string;
  packages:Plan[]=[]
  hour = 'highlight';

  //   {
  //     id: 1,
  //     name: '1 Hour',
  //     description: 'Quick browsing session',
  //     price: 20,
  //     duration: '1 Hour',
  //     data: 'Unlimited',
  //     devices: 1,
  //     icon: 'time-outline',
  //     iconClass: 'hour'
  //   }
  // ];

  constructor(private subService:SubscriptionService,private fb:FormBuilder,private route: ActivatedRoute,private http: HttpClient,private voucherService:VouchersService) {}

  ngOnInit() {
    this.detailForm = this.fb.group({
      'id':{disabled:true},
      'phone':['',Validators.required],
      'amount':{disabled:true},
      'station':{disabled:true},
      'plan':{disabled:true},


  })
    
    this.voucherService.getPlans().subscribe(data=>{
      console.log(data.results.filter(plan=>plan.plan_type == "WIFI"))
      this.packages =data.results.filter(plan=>plan.plan_type == "WIFI");
      this.stationid=data.station
    })

    this.payment_method = this.route.snapshot.paramMap.get('payment_method');
    this.user_type = this.route.snapshot.paramMap.get("user_type")
    this.invoice_id = this.route.snapshot.paramMap.get("invoice_id")
  }

  selectService(service: string) {
    this.selectedService = service;
    this.showPackages = true;
  }

  goBack() {
    this.showPackages = false;
    this.selectedService = '';
  }

  openPurchaseDialog(pkg:any=null) {
    if (pkg){
      this.selectedPackage = pkg;
      this.showPurchaseModal = true;
      this.resetForm();
    }else{
       this.showPurchaseModal = true;
      this.resetForm();
    }
  }

  closePurchaseDialog() {
    this.showPurchaseModal = false;
    this.selectedPackage = null;
    this.resetForm();
  }

  resetForm() {
    this.phoneNumber = '';
    this.errorMessage = '';
    this.successMessage = '';
    this.isLoading = false;
  }

  submitPurchase() {
    if (!this.phoneNumber || this.phoneNumber.length !== 10) {
      this.errorMessage = 'Please enter a valid 9-digit phone number';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.successMessage = '';
    let d = this.subService.getData()
    console.log(d)
    const payload = {
      phone: `${this.phoneNumber}`,
      plan_id: this.selectedPackage?.id,
      package_name: this.selectedPackage?.name,
      hotspot:d['station'],
      amount: this.selectedPackage?.amount,
      service_type: this.selectedService,
      invoice:this.invoice_id,
  
    };
    
    this.isLoading = false;
    this.voucherService.makePayment(payload)
    .subscribe({
  next: (data) => {
    this.successMessage = data.message;
    this.isLoading = false;
  },
  error: (error) => {
    console.error(error);
    this.errorMessage = error?.error?.message || 'Payment failed';
    this.isLoading = false;
  }
  });


    // For testing without API - remove this in production
    // this.simulatePayment();
  }


}